// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"Error_errorContainer__NsstD","errorMessage":"Error_errorMessage__pw4gS","retryButton":"Error_retryButton__3A1MU","contactButton":"Error_contactButton__iE3RF"};